export const calculatePermissions = (groups: string[]) => {
  const perms = [];

  if (groups.includes('bettors')) {
    perms.push('customerHome', 'customerBanking', 'customerBetting');
  }
  if (groups.includes('account_manager')) {
    perms.push('agentAccounts', 'mollyWL');
  }
  if (groups.includes('customer_manager')) {
    perms.push(
      'agentHome',
      'agentBanking',
      'customer',
      'agentBetting',
      'mollyWL'
    );
  }
  if (groups.includes('finance_manager')) {
    perms.push(
      'agentHome',
      'agentBanking',
      'agentBetting',
      'provider',
      'mollyWL',
      'agentReconcile'
    );
  }
  if (groups.includes('fakeadmin')) {
    perms.push('agentHome');
  }
  if (groups.includes('admin_user')) {
    perms.push('admin');
  }
  if (groups.includes('superuser')) {
    perms.push('admin');
  }

  return [...new Set(perms)];
};

export default calculatePermissions;
